export default {
  title: "RH Button Add Membership",
  type: "rh/components/content/rhbuttonaddmembership",
  isContainer: false,
  config: {
    emptyLabel: "RH Button Add Membership",
    isEmpty: () => false
  }
};
